/* src/app/pages/validation/validation.component.scss */
.default-flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.default-flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.default-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.default-flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.default-flex-column {
  display: flex;
  flex-flow: column;
}
.default-flex-stretch {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-content: stretch;
}
.rounded-circle {
  border-radius: 50%;
}
h1,
h2,
h3,
h4,
h5,
h6,
label,
p,
b,
small,
span,
strong {
  margin: 0px;
  -webkit-font-smoothing: antialiased;
}
h1.cds-required::after,
h2.cds-required::after,
h3.cds-required::after,
h4.cds-required::after,
h5.cds-required::after,
h6.cds-required::after,
label.cds-required::after,
p.cds-required::after,
b.cds-required::after,
small.cds-required::after,
span.cds-required::after,
strong.cds-required::after {
  font-family: var(--cds-font-family);
  font-size: inherit;
  font-weight: inherit;
  color: var(--cds-danger-500);
  line-height: inherit;
  content: "*";
}
h1[class^=c-],
h2[class^=c-],
h3[class^=c-],
h4[class^=c-],
h5[class^=c-],
h6[class^=c-],
label[class^=c-],
p[class^=c-],
b[class^=c-],
small[class^=c-],
span[class^=c-],
strong[class^=c-] {
  color: var(--color);
}
b,
strong,
span {
  font-family: var(--cds-font-family);
}
h1 {
  font-family: var(--cds-font-family);
  font-size: 30px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
h2 {
  font-family: var(--cds-font-family);
  font-size: 24px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
h3 {
  font-family: var(--cds-font-family);
  font-size: 22px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
h4 {
  font-family: var(--cds-font-family);
  font-size: 20px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
h5 {
  font-family: var(--cds-font-family);
  font-size: 18px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
h6 {
  font-family: var(--cds-font-family);
  font-size: 16px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
p {
  font-family: var(--cds-font-family);
  font-size: 14px;
  font-weight: normal;
  color: var(--cds-text-medium);
  line-height: 1;
}
p.bold {
  font-weight: bold;
}
label {
  font-family: var(--cds-font-family);
  font-size: 14px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
small {
  font-family: var(--cds-font-family);
  font-size: 12px;
  font-weight: normal;
  color: var(--cds-text-strong);
  line-height: 1;
}
:host {
  --header-size: 65px;
  --dot-size: 8px;
  --dot-scale: 12px;
}
:host main {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 32px;
  height: calc(100vh - var(--header-size));
  animation: screenLoadingAnimation 0.5s linear forwards;
  transform: translateX(-50px);
  opacity: 0;
}
:host main section {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
}
:host main section p {
  font-size: 16px;
  color: var(--cds-text-strong);
  text-align: center;
  line-height: 1.3;
}
:host .loader {
  width: 48px;
  height: 48px;
  --dot:
    radial-gradient(
      circle closest-side,
      var(--cds-primary-600) 90%,
      transparent);
  background:
    var(--dot) 0% 50%,
    var(--dot) 50% 50%,
    var(--dot) 100% 50%;
  background-size: 33.3333333333% var(--dot-size);
  background-repeat: no-repeat;
  animation: dotAnimation 1.9s infinite linear;
}
:host ::ng-deep .validation-error-title {
  display: block;
  font-size: 18px;
  font-weight: bold;
}
@keyframes dotAnimation {
  0% {
    background-size:
      33.3333333333% var(--dot-size),
      33.3333333333% var(--dot-size),
      33.3333333333% var(--dot-size);
  }
  16% {
    background-size:
      33.3333333333% var(--dot-scale),
      33.3333333333% var(--dot-size),
      33.3333333333% var(--dot-size);
  }
  32% {
    background-size:
      33.3333333333% var(--dot-size),
      33.3333333333% var(--dot-size),
      33.3333333333% var(--dot-size);
  }
  48% {
    background-size:
      33.3333333333% var(--dot-size),
      33.3333333333% var(--dot-scale),
      33.3333333333% var(--dot-size);
  }
  64% {
    background-size:
      33.3333333333% var(--dot-size),
      33.3333333333% var(--dot-size),
      33.3333333333% var(--dot-size);
  }
  80% {
    background-size:
      33.3333333333% var(--dot-size),
      33.3333333333% var(--dot-size),
      33.3333333333% var(--dot-scale);
  }
  100% {
    background-size:
      33.3333333333% var(--dot-size),
      33.3333333333% var(--dot-size),
      33.3333333333% var(--dot-size);
  }
}
@keyframes screenLoadingAnimation {
  0% {
    transform: translateX(-50px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
/*# sourceMappingURL=validation.component.css.map */
